import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Select,
  Radio,
  DatePicker,
  Input,
  Button,
  Drawer,
  Spin,
  message,
} from "antd";
import { CheckOutlined, EyeOutlined } from "@ant-design/icons";
// import { CheckOutlined } from "@ant-design/icons";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { BASE_CRM_URL } from "../../../components/config/config";
import dayjs from "dayjs";
import QuillEditor from "../Sales/DynamicScreen/QuillEditor";

const Campaign = () => {
  const [campaignName, setCampaignName] = useState("");

  // Related type
  const [relatedOptions, setRelatedOptions] = useState([]);
  const [relatedLoading, setRelatedLoading] = useState(false);
  const [selectedRelated, setSelectedRelated] = useState(null);
  const [selectedRelatedName, setSelectedRelatedName] = useState("");

  // Customers / Leads
  const [customerOptions, setCustomerOptions] = useState([]);
  const [leadOptions, setLeadOptions] = useState([]);
  const [selectedLead, setSelectedLead] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);

  // Campaign fields
  const [messageType, setMessageType] = useState("");
  const [emailTemplate, setEmailTemplate] = useState("");
  const [scheduling, setScheduling] = useState(null);
  const [prefilledMessage, setPrefilledMessage] = useState("");

  console.log(prefilledMessage, "emiallllllllllll");

  // Contact selection
  const [selectionMode, setSelectionMode] = useState("");
  const [selectedContacts, setSelectedContacts] = useState([]);

  const [saving, setSaving] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const [emailTemplates, setEmailTemplates] = useState([]);
  const [emailTemplateLoading, setEmailTemplateLoading] = useState(false);

  /*
   * Fetch Related Types
   */
  const getRelatedTypes = async () => {
    try {
      setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}RelatedToType`);
      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.RelatedToType,
          name: item.RelatedToType,
        }));

        setRelatedOptions(options);
      } else {
        setRelatedOptions([]);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
      message.error("Failed to load related types");
    } finally {
      setRelatedLoading(false);
    }
  };

  /*
   * Fetch Customers
   */
  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);

      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const options = data.ResultData.map((item) => ({
          value: String(item.customerId),
          label: item.company || item.name || `Customer ${item.customerId}`,
        }));

        setCustomerOptions(options);
      } else {
        setCustomerOptions([]);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      message.error("Failed to load customers");
    }
  };

  /*
   * Fetch Leads
   */
  const getLeads = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}leads/GetLeads`);

      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const options = data.ResultData.map((item) => ({
          value: String(item.id),
          label: item.name || `Lead ${item.id}`,
        }));

        setLeadOptions(options);
      } else {
        setLeadOptions([]);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
      message.error("Failed to load leads");
    }
  };

  const getEmailTemplates = async () => {
    try {
      setEmailTemplateLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}Email/GetCampaignEmailTemplates`,
      );

      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const templates = data.ResultData.filter(
          (item) => Number(item.active) === 1,
        ).map((item) => ({
          value: String(item.emailtemplateid),
          label: item.name,
          subject: item.subject,
          message: item.message,
          slug: item.slug,
        }));

        setEmailTemplates(templates);
      } else {
        setEmailTemplates([]);
      }
    } catch (error) {
      console.error("Error fetching email templates:", error);
      setEmailTemplates([]);
    } finally {
      setEmailTemplateLoading(false);
    }
  };

  /*
   * Initial API calls
   */
  useEffect(() => {
    getRelatedTypes();
    getCustomers();
    getLeads();
    getEmailTemplates();
  }, []);

  /*
   * Contact selection
   */
  //   useEffect(() => {
  //     if (selectionMode === "All" || selectionMode === "Exclude") {
  //       const allIds = mockContacts.map((contact) => contact.id);
  //       setSelectedContacts(allIds);
  //     } else {
  //       setSelectedContacts([]);
  //     }
  //   }, [selectionMode]);

  //   const handleContactToggle = (contactId) => {
  //     setSelectedContacts((previous) => {
  //       if (previous.includes(contactId)) {
  //         return previous.filter((id) => id !== contactId);
  //       }

  //       return [...previous, contactId];
  //     });
  //   };

  /*
   * Related type change
   */
  const handleRelatedChange = (value) => {
    const selectedOption = relatedOptions.find(
      (option) => option.value === value,
    );

    const relatedName = (selectedOption?.name || "").toLowerCase();

    const leadSelected =
      relatedName.includes("lead") && !relatedName.includes("customer");

    const customerSelected =
      relatedName.includes("customer") || relatedName.includes("client");

    setSelectedRelated(value);
    setSelectedRelatedName(selectedOption?.name || "");

    // Reset previous selection
    setSelectedLead([]);
    setSelectedCustomer([]);

    // Do NOT select Exclude automatically
    setSelectionMode("");

    if (leadSelected && leadOptions.length > 0) {
      setSelectedLead(leadOptions.map((item) => item.value));
    }

    if (customerSelected && customerOptions.length > 0) {
      setSelectedCustomer(customerOptions.map((item) => item.value));
    }
  };

  /*
   * Determine whether related type is Lead or Customer
   */
  const relatedName = selectedRelatedName.toLowerCase();

  const isLead =
    relatedName.includes("lead") && !relatedName.includes("customer");

  const isCustomer =
    relatedName.includes("customer") || relatedName.includes("client");

  useEffect(() => {
    if (isLead && leadOptions.length > 0 && selectedLead.length === 0) {
      setSelectedLead(leadOptions.map((item) => item.value));
    }
  }, [isLead, leadOptions]);

  useEffect(() => {
    if (
      isCustomer &&
      customerOptions.length > 0 &&
      selectedCustomer.length === 0
    ) {
      setSelectedCustomer(customerOptions.map((item) => item.value));
    }
  }, [isCustomer, customerOptions]);

  /*
   * Save campaign
   */
  const handleSave = async () => {
    if (!campaignName.trim()) {
      message.warning("Please enter campaign name");
      return;
    }

    if (!selectedRelated) {
      message.warning("Please select Related type");
      return;
    }

    if (!messageType) {
      message.warning("Please select message type");
      return;
    }

    if (!scheduling) {
      message.warning("Please select scheduling date and time");
      return;
    }

    if (!selectionMode) {
      message.warning("Please select All or Exclude");
      return;
    }

    if (selectedContacts.length === 0) {
      message.warning("Please select at least one contact");
      return;
    }

    if (messageType === "email" && !emailTemplate) {
      message.warning("Please select an email template");
      return;
    }

    const payload = {
      campaignName: campaignName.trim(),

      relatedType: selectedRelated,
      relatedTypeName: selectedRelatedName,

      customerIds: isCustomer ? selectedCustomer : [],
      leadIds: isLead ? selectedLead : [],

      messageType,

      scheduling: dayjs(scheduling).format("YYYY-MM-DD HH:mm:ss"),

      selectionMode,

      selectedContacts,

      ...(messageType === "email" && {
        emailTemplate,
        prefilledMessage,
      }),
    };

    try {
      setSaving(true);

      console.log("Saving Campaign Data:", payload);

      /*
       * Add your campaign POST API here.
       *
       * Example:
       *
       * const response = await fetch(
       *   `${BASE_CRM_URL}campaigns/CreateCampaign`,
       *   {
       *     method: "POST",
       *     headers: {
       *       "Content-Type": "application/json",
       *     },
       *     body: JSON.stringify(payload),
       *   }
       * );
       *
       * const data = await response.json();
       */

      message.success("Campaign data saved successfully");
    } catch (error) {
      console.error("Error saving campaign:", error);
      message.error("Failed to save campaign");
    } finally {
      setSaving(false);
    }
  };

  /*
   * Cancel / Reset
   */
  const handleCancel = () => {
    setCampaignName("");
    setSelectedRelated(null);
    setSelectedRelatedName("");
    setSelectedLead([]);
    setSelectedCustomer([]);
    setSelectedContacts([]);
    setSelectionMode("");
    setMessageType("");
    setEmailTemplate("");
    setScheduling(null);
    setPrefilledMessage("");
  };

  return (
    <div className="page-wrapper">
      {saving && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255,255,255,0.7)",
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}

      <div className="content">
        {/* Header */}
        <div className="d-flex justify-content-between mb-2">
          <div className="d-flex flex-column">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/crm/dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>

                {/* <li className="" aria-current="page">
                  <h4>New Messaging Campaign</h4>
                </li> */}
                <h4 className="breadcrumb-item " aria-current="page">
                  New Messaging Campaign
                </h4>
              </ol>
            </nav>

            {/* <p className="text-muted">Manage campaigns here</p> */}
          </div>
        </div>

        <div className="card p-4">
          {/* Campaign Name */}
          <div className="row mb-3">
            <div className="col-4">
              <label className="form-label fw-bold">Campaign Name</label>

              <Input
                placeholder="Enter Campaign Name"
                value={campaignName}
                onChange={(e) => setCampaignName(e.target.value)}
                style={{
                  width: "100%",
                  height: "40px",
                }}
              />
            </div>

            {/* Related */}
            <div className="col-md-2 mb-2">
              <label className="form-label fw-bold">Related</label>

              <Select
                options={relatedOptions}
                value={selectedRelated}
                loading={relatedLoading}
                placeholder="Select Related"
                style={{
                  width: "100%",
                  height: 38,
                }}
                onChange={handleRelatedChange}
              />
            </div>

            {/* Lead / Customer */}
            <div className="col-md-4 mb-2">
              <label className="form-label fw-bold">
                {isLead
                  ? "Select Leads"
                  : isCustomer
                    ? "Select Customers"
                    : "Lead / Customer"}
              </label>

              <div
                style={{
                  position: "relative",
                  width: "100%",
                }}
              >
                <Select
                  mode="multiple"
                  showSearch
                  style={{
                    width: "100%",
                    height: 38,
                  }}
                  placeholder={
                    !selectedRelated
                      ? "Select Related first"
                      : isLead
                        ? "Select Leads"
                        : isCustomer
                          ? "Select Customers"
                          : "Lead / Customer"
                  }
                  disabled={!selectedRelated}
                  loading={
                    isLead
                      ? leadOptions.length === 0
                      : isCustomer
                        ? customerOptions.length === 0
                        : false
                  }
                  options={
                    isLead ? leadOptions : isCustomer ? customerOptions : []
                  }
                  value={
                    isLead ? selectedLead : isCustomer ? selectedCustomer : []
                  }
                  maxTagCount={0}
                  maxTagPlaceholder={() => null}
                  tagRender={() => null}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  optionRender={(option) => {
                    const isSelected = isLead
                      ? selectedLead.includes(option.value)
                      : selectedCustomer.includes(option.value);

                    return (
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{
                          width: "100%",
                          padding: "4px 0",
                        }}
                      >
                        <span>{option.label}</span>

                        {isSelected && (
                          <CheckOutlined
                            style={{
                              color: "#52c41a",
                              fontSize: 16,
                              fontWeight: "bold",
                            }}
                          />
                        )}
                      </div>
                    );
                  }}
                  onChange={(values) => {
                    if (!selectionMode) return;

                    if (isLead) {
                      setSelectedLead(values);
                    }

                    if (isCustomer) {
                      setSelectedCustomer(values);
                    }
                  }}
                />

                {/* Eye button beside dropdown arrow */}
                <Button
                  type="text"
                  icon={<EyeOutlined />}
                  disabled={!selectedRelated}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setDrawerOpen(true);
                  }}
                  style={{
                    position: "absolute",
                    right: 28,
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: 24,
                    height: 24,
                    padding: 0,
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#b5b5b5",
                    background: "transparent",
                  }}
                />
              </div>
            </div>
            {/* Exclude */}
            <div className="col-md-2 mb-2">
              <label className="form-label fw-bold d-block">Selection</label>

              <Radio.Group
                value={selectionMode}
                onChange={(e) => {
                  setSelectionMode(e.target.value);
                }}
              >
                <Radio value="Exclude">Exclude</Radio>
              </Radio.Group>
            </div>
          </div>

          {/* Scheduling + Message Type + Email Template */}
          <div className="row mb-3">
            {/* Scheduling */}
            <div className="col-md-4">
              <label className="form-label fw-bold">Scheduling</label>

              <DatePicker
                showTime
                value={scheduling}
                placeholder="Select date/time"
                style={{
                  width: "100%",
                  height: "40px",
                }}
                onChange={(date) => setScheduling(date)}
              />
            </div>

            {/* Message Type */}
            <div className="col-md-4">
              <label className="form-label fw-bold">Message Type</label>

              <Select
                placeholder="WhatsApp / Email"
                style={{
                  width: "100%",
                  height: "40px",
                }}
                value={messageType || undefined}
                onChange={(value) => {
                  setMessageType(value);

                  if (value === "whatsapp") {
                    setEmailTemplate("");
                    setPrefilledMessage("");
                  }
                }}
                options={[
                  {
                    value: "whatsapp",
                    label: "WhatsApp",
                  },
                  {
                    value: "email",
                    label: "Email",
                  },
                ]}
              />
            </div>

            {/* Email Template */}
            {/* Email Template */}
            {messageType === "email" && (
              <div className="col-md-4">
                <label className="form-label fw-bold">Email Template</label>

                <Select
                  showSearch
                  placeholder="Select email template"
                  style={{
                    width: "100%",
                    height: "38px",
                  }}
                  loading={emailTemplateLoading}
                  value={emailTemplate || undefined}
                  options={emailTemplates}
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label || "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    setEmailTemplate(value);

                    const selectedTemplate = emailTemplates.find(
                      (item) => item.value === value,
                    );

                    setPrefilledMessage(selectedTemplate?.message || "");
                  }}
                />
              </div>
            )}
          </div>

          {/* Prefilled Message */}
          {messageType === "email" && (
            <div className="row mb-4">
              <div className="col-12">
                <label className="form-label fw-bold">Prefilled Message</label>

                <QuillEditor
                  key={emailTemplate || "empty-template"}
                  initialValue={prefilledMessage}
                  onChange={setPrefilledMessage}
                />
              </div>
            </div>
          )}

          {/* Actions */}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button
              size="large"
              onClick={handleCancel}
              style={{
                borderRadius: "6px",
              }}
              disabled={saving}
            >
              Cancel
            </Button>

            <Button
              type="primary"
              size="large"
              onClick={handleSave}
              loading={saving}
              style={{
                borderRadius: "6px",
                backgroundColor: "#1677ff",
              }}
            >
              Save
            </Button>
          </div>
        </div>
        <Drawer
          title={
            isLead
              ? "Select Leads"
              : isCustomer
                ? "Select Customers"
                : "Select Records"
          }
          placement="right"
          width={650}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <div className="row">
            {(isLead ? leadOptions : customerOptions).map((item) => {
              const isSelected = isLead
                ? selectedLead.includes(item.value)
                : selectedCustomer.includes(item.value);

              const handleToggle = () => {
                if (isLead) {
                  setSelectedLead((prev) => {
                    if (prev.includes(item.value)) {
                      return prev.filter((id) => id !== item.value);
                    }

                    return [...prev, item.value];
                  });
                } else {
                  setSelectedCustomer((prev) => {
                    if (prev.includes(item.value)) {
                      return prev.filter((id) => id !== item.value);
                    }

                    return [...prev, item.value];
                  });
                }
              };

              return (
                <div key={item.value} className="col-md-4 mb-2">
                  <div
                    onClick={handleToggle}
                    className="border rounded p-2"
                    style={{
                      cursor: "pointer",
                      minHeight: 45,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: isSelected ? "#f6ffed" : "#fff",
                      borderColor: isSelected ? "#b7eb8f" : "#d9d9d9",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        paddingRight: 8,
                      }}
                      title={item.label}
                    >
                      {item.label}
                    </span>

                    {isSelected && (
                      <CheckOutlined
                        style={{
                          color: "#52c41a",
                          fontSize: 16,
                          flexShrink: 0,
                        }}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </Drawer>

        <CommonFooter />
      </div>
    </div>
  );
};

export default Campaign;
